import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ExtensionDeleteConnectionModalProps, ExtensionConnectionTypes } from 'src/Libs/installation-extensions/types'
import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { useExtensionConnection } from 'src/Libs/installation-extensions/hooks/extensions'

/**
 * A modal to delete the connection to ai360 power fix.
 */
const Ai360PowerFixDeleteConnectionModal: React.FC<ExtensionDeleteConnectionModalProps> = ({
  loadInstallationExtensionStates,
  onClose: closeAi360PowerFixDeleteConnectionModal,
  place = 0,
}) => {
  const { t } = useCustomTranslation()
  const { handleDeleteExtensionConnection } = useExtensionConnection(ExtensionConnectionTypes.Ai360PowerFix)

  const handleOnClick = async (): Promise<void> => {
    try {
      const result = await handleDeleteExtensionConnection()
      if (!result) return

      await loadInstallationExtensionStates()
      closeAi360PowerFixDeleteConnectionModal()
    } catch (e) {
      console.error('Error deleting extension connection:', e)
      closeAi360PowerFixDeleteConnectionModal()
    }
  }

  const modalActions = {
    primary: {
      name: t('common.remove'),
      onClick: handleOnClick,
    },
    secondary: { name: t('common.cancel') },
  }

  return (
    <Dialog
      title={t('installation-extensions.ai360-power-fix.details.connection-deletion-modal.title')}
      onClose={closeAi360PowerFixDeleteConnectionModal}
      actions={modalActions}
      maxWidth="sm"
    >
      <Typography variant="body2" mt={4}>
        {t('installation-extensions.ai360-power-fix.details.connection-deletion-modal.description')}
      </Typography>
    </Dialog>
  )
}

export default Ai360PowerFixDeleteConnectionModal
